import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Header from "../../layout/Header";
import PersonalInfoSection from "./components/PersonalInfoSection";
import PhysicalDetailsSection from "./components/PhysicalDetailsSection";
import SubscriptionSection from "./components/SubscriptionSection";
import ActionButtons from "./components/ActionButtons";
import DeleteConfirmationModal from "./components/DeleteConfirmationModal";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  createTrainerService,
  deleteTrainerService,
  getTrainerByIdService,
  getTrainersService,
  updateTrainerService,
} from "redux/services/trainers_service";
import { useLanguage } from "LanguageContext";

const AddEditTrainerProfile = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();

  const { trainerInfo } = useSelector((state) => state.trainers);

  const { language } = useLanguage();

  const [isEditMode, setIsEditMode] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isArabic, setIsArabic] = useState(language == "ar" ? true : false);
  const [formData, setFormData] = useState({
    name: isEditMode ? trainerInfo?.name : "",
    phone: isEditMode ? trainerInfo?.phone : "",
    address: isEditMode ? trainerInfo?.address : "",
    birth_date: isEditMode ? trainerInfo?.address : "",
  });
  const [errors, setErrors] = useState({});

  const queryParams = new URLSearchParams(location.search);
  const trainerId = queryParams.get("id");

  useEffect(() => {
    //  const trainerId = location.state?.id;
    if (trainerId) {
      setIsEditMode(true);

      dispatch(getTrainerByIdService(trainerId)).then((response) => {
        console.log(response?.payload?.data?.data);
        if (response.payload.status == 200) {
          setFormData(response?.payload?.data?.data);
        }
      });
    }
  }, [location]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Clear error when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = isArabic
        ? "الاسم الكامل مطلوب"
        : "Full name is required";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = isArabic
        ? "رقم الهاتف مطلوب"
        : "Phone number is required";
    }

    if (!formData.address.trim()) {
      newErrors.address = isArabic ? "العنوان مطلوب" : "Address is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    console.log(formData);
    if (validateForm()) {
      if (isEditMode !== true) {
        dispatch(createTrainerService(formData))
          .then((response) => {
            console.log(response);
            if (
              response?.payload?.status === 200 ||
              response?.payload?.status === 201
            ) {
            toast.success(
                         language === "ar"
                           ? "  تمت عملية الإضافة بنجاح "
                           : "Added successfully !"
                       );
              navigate("/trainers");
            } else {
          Object.values(response.payload.errors).forEach((errorArray) => {
                       errorArray.forEach((errorMessage) => {
                         toast.warn(errorMessage);
                       });
                     });
            }
          })
          .catch((error) => {
            console.error(error);
            toast.error("An error occurred");
          })
          .finally(() => {
            //   setLoading(false); // Stop loading
          });
      } else {
        dispatch(updateTrainerService({ id: trainerId, formData: formData }))
          .then((response) => {
            console.log(response);
            if (
              response?.payload?.status === 200 ||
              response?.payload?.status === 201
            ) {
                toast.success(
                            language === "ar"
                              ? "  تمت عملية التعديل بنجاح "
                              : "Updated successfully !"
                          );
              navigate("/trainers");
            } else {
                  Object.values(response.payload.errors).forEach((errorArray) => {
                              errorArray.forEach((errorMessage) => {
                                toast.warn(errorMessage);
                              });
                            });
            }
          })
          .catch((error) => {
            console.error(error);
            toast.error("An error occurred");
          })
          .finally(() => {
            //   setLoading(false); // Stop loading
          });
      }

      // navigate('/client-management');
    }
  };

  const handleCancel = () => {
    navigate("/trainers");
  };

  const handleDelete = () => {
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    dispatch(deleteTrainerService(trainerId)).then((response) => {
      if (
        response.payload?.status === 200 ||
        response.payload?.status === 201 ||
        response.payload?.status === 204
      ) {
        toast.success(
          language === "ar" ? "تم الحذف بنجاح" : "Deleted successfully"
        );

        dispatch(getTrainersService({ page: 1 }));
        setShowDeleteModal(false);
        navigate("/trainers");
      }
    });
  };

  return (
    <div
      className={`min-h-screen bg-gray-50 ${isArabic ? "rtl" : "ltr"}`}
      dir={isArabic ? "rtl" : "ltr"}
    >
      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="p-8">
            <div className="max-w-2xl mx-auto">
              <PersonalInfoSection
                formData={formData}
                errors={errors}
                isArabic={isArabic}
                onInputChange={handleInputChange}
              />

              <ActionButtons
                isEditMode={isEditMode}
                isArabic={isArabic}
                onSave={handleSave}
                onCancel={handleCancel}
                onDelete={handleDelete}
              />
            </div>
          </div>
        </div>
      </main>

      {showDeleteModal && (
        <DeleteConfirmationModal
          isArabic={isArabic}
          clientName={clientInfo?.name}
          onConfirm={confirmDelete}
          onCancel={() => setShowDeleteModal(false)}
        />
      )}
    </div>
  );
};

export default AddEditTrainerProfile;
